"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _gdgl;
var _default = exports.default = {
  all: {
    day: "日",
    month: "月",
    year: "年",
    hour: "时",
    week: "周",
    monday: "周一",
    tuesday: "周二",
    wednesday: "周三",
    thursday: "周四",
    friday: "周五",
    saturday: "周六",
    sunday: "周日",
    startTime: "开始日期",
    endTime: "结束日期",
    ksxz: "快速选择",
    sjjg: "时间间隔",
    ys: "原始",
    wfz: "五分钟",
    yxs: "一小时",
    zjst: "最近三天",
    zjyz: "最近一周",
    zjyy: "最近一月",
    zjsy: "最近三月",
    zjly: "最近六月",
    zjyn: "最近一年",
    zjsn: "最近三年",
    cx: "查询",
    dc: "导出",
    sjxz: "数据选择",
    qx: "取消",
    bc: "保存",
    timexz: "时间选择",
    quanxuan: "全选",
    fx: "反选",
    xz: "下载",
    yl: "预览",
    pldc: "批量导出",
    sc: "上传",
    wu: "无",
    rq: "日期"
  },
  login: {
    welcome: "欢迎使用iot管理系统",
    title: "数字化机房管理平台",
    loginBtn: "登录",
    usernameRule: "用户名为必填项",
    passwordRule: "密码为必填项",
    codeRule: "请输入验证码",
    username: "用户名",
    password: "密码",
    code: "验证码",
    codeError: "验证码获取失败，点击重新获取"
  },
  home: {
    title: "能碳管理平台",
    admin: "后台管理"
  },
  head: {
    jsc: "驾驶舱",
    yxjk: "运行监控",
    sjfx: "数据分析",
    yxbb: "运行报表",
    ywgl: "运维管理",
    htgl: "后台管理",
    qp: "全屏",
    fh: "返回"
  },
  home_page: {
    nhsj: "能耗数据",
    nxsj: "能效数据",
    sbcs: "设备参数",
    jnl: "节能量",
    nhzb: "能耗占比",
    ssnx: "实时能效",
    rhdl: "日耗电量",
    rnx: "日能效",
    rgll: "日供冷量",
    ldswd: "冷却水温度"
  },
  eedata: {
    dCop: "当日能效",
    mCop: "当月能效",
    yCop: "当年能效",
    target: "目标值"
  },
  esdata: {
    jnlD: "当日节能率及节能量",
    jnlM: "当月节能率及节能量",
    jnlY: "当年节能率及节能量",
    jnl: "节能量"
  },
  dataQuery: {
    sjfx: "数据分析",
    nhhz: "能耗汇总",
    lssj: "历史数据",
    nhcx: "能耗查询",
    sbnhzb: "设备能耗占比",
    csxz: "参数选择",
    nxrl: "能效日历",
    jxgs: "急需改善",
    yb: "一般",
    lh: "良好",
    yx: "优秀",
    wdxz: "纬度选择",
    sjxz: "时间选择",
    dw: "单位:千瓦时（kWh）",
    dc: "导出",
    wdcx: "我的查询",
    fam: "方案名",
    drsbnhzb: "当日设备能耗占比",
    rbx: "日能效",
    zll: "制冷量",
    rhdl: "日耗电量",
    gldj: "供冷单价",
    gjcs: "关键参数",
    ldbscxs: "冷冻泵输送系数",
    lqbscxz: "冷却泵输送系数",
    lqtxtnx: "冷却塔系统能效",
    nh: "能耗",
    zb: "占比"
  },
  report: {
    rbb: "日报表",
    ybb: "月报表",
    nbb: "年报表",
    sbyxrz: "设备运行日志",
    yxzd: "运行诊断",
    bj: "报警",
    jnl: "节能量",
    hdl: "耗电量",
    glfb: "供冷分布",
    zjll: "装机容量",
    drsbnhzb: "当日设备能耗占比",
    nhgl: "能耗概览",
    nhzb: "能耗占比",
    sjtj: "数据统计",
    nxgl: "能效概览",
    glsc: "供冷时长",
    dgsd: "低谷时段",
    gfsd: "高峰时段",
    psd: "平时段",
    gll: "供冷量",
    fhl: "负荷率",
    zj: "主机",
    lqsb: "冷却水泵",
    ldsb: "冷冻水泵",
    lqt: "冷却塔",
    lj: "冷价",
    nx: "能效",
    rdf: "日电费",
    ydf: "月电费",
    lqb: "冷却泵",
    yglsc: "月供冷时长",
    rjglsc: "日均供冷时长",
    yglts: "月供冷天数"
  },
  rb: {
    title: "供冷日报",
    date: "日期",
    temperature: "温度: ",
    humidity: "相对湿度: ",
    wet_bulb_temperature: "湿球温度: ",
    energy_efficiency: "今天您机房的平均能效是: ",
    cooling_price: "冷价是: ",
    cooling_quantity: "供冷量是: ",
    power_consumption: "耗电量是: ",
    estimated_cost: "预估电费: ",
    start_time: "今天的开机时间是: ",
    end_time: "今天的关机时间是: ",
    cooling_duration: "一共供冷:",
    average_supply_temperature: "今天的平均冷冻供水温度为: ",
    temperature_difference: "平均供水温差为: ",
    average_return_temperature: "今天的平均冷却回水温度为: ",
    approach_degree: "平均逼近度为: ",
    year_to_date_efficiency: "截至今日,本机房全年综合能效值为: ",
    year_to_date_cooling_price: "冷价为: ",
    encouragement: "加油!"
  },
  nb: {
    title: "供冷月报",
    energy_efficiency: "本月您机房的平均能效是: ",
    cooling_price: "本月您机房的平均冷价是: ",
    cooling_quantity: "总供冷量是: ",
    power_consumption: "耗电量是: ",
    estimated_cost: "预估电费: ",
    total_cooling_duration: "本月总供冷时长: ",
    daily_cooling_duration: "日均供冷时长: ",
    wet_bulb_temperature: "平均湿球温度: ",
    as_of_yesterday: "截至昨日",
    as_of_end_of_month: "截至本月末",
    year_to_date_efficiency: "本机房全年综合能效值为: ",
    year_to_date_cooling_price: "冷价为: ",
    encouragement: "加油!",
    compare_last_month: "对比上月"
  },
  nbyl: {
    date: "日期",
    host_power_consumption: "主机耗电量(kWh)",
    freezer_pump_power_consumption: "冷冻泵耗电量(kWh)",
    cooling_pump_power_consumption: "冷却泵耗电量(kWh)",
    cooling_tower_power_consumption: "冷却塔耗电量(kWh)",
    total_power_consumption: "总电量(kWh)",
    total_cooling_capacity: "总供冷量(kWh)",
    electricity_fee: "电费(RM)",
    comprehensive_efficiency: "综合能效"
  },
  yb: {
    annual_report_title: "供冷年报",
    average_efficiency: "全年您机房的平均能效是:",
    cooling_price: "全年您机房的平均冷价是:",
    cooling_capacity: "总供冷量是:",
    power_consumption: "耗电量是:",
    estimated_cost: "预估电费:",
    total_supply_duration: "全年总供冷时长:",
    daily_supply_duration: "日均供冷时长:",
    cooling_days: "全年供冷天数:",
    xzndbg: "下载年度报告"
  },
  runType: {
    yxrz: "运行日志",
    bh: "编号",
    sj: "时间",
    lx: "类型",
    mc: "名称",
    shijian: "事件",
    sbsszt: "设备实时状态",
    zj: "主机",
    ldxt: "冷冻系统",
    lqxt: "冷却系统",
    lqtxt: "冷却塔系统",
    bjhf: "报警恢复",
    fsbj: "报警",
    sbqt: "设备启停",
    qd: "启动",
    tz: "停止"
  },
  diagnosis: {
    start_time: "开始时间",
    select_start_time: "选择开始时间",
    end_time: "结束时间",
    select_end_time: "选择结束时间",
    diagnose: "诊断",
    view_diagnosis_history: "诊断历史查看",
    download: "下载",
    basic_info: "基本信息",
    time_interval: "时间区间",
    to: "至",
    startup_duration: "开机时长",
    hours: "小时",
    average_efficiency: "机房平均能效",
    power_consumption: "机房耗电量",
    cooling_capacity: "机房供冷量",
    supply_water_temperature: "冷冻水供水温度",
    diagnosis_abnormal_info: "诊断异常信息",
    room_is_running_smoothly: "机房运行良好",
    operation_suggestions: "运行建议",
    no_suggestions: "暂无运行建议",
    comprehensive_score: "综合评分",
    diagnosis_analysis: "诊断分析",
    cancel: "取消",
    lqsxtnx: "冷却水系统能效",
    jfnx: "机房能效",
    lqtxtnx: "冷却塔系统能效",
    ldsxtnx: "冷冻水系统能效",
    zjnx: "主机能效"
  },
  alarm: {
    alarm_statistics: "报警统计",
    today: "当日",
    this_month: "当月",
    this_year: "当年",
    alarm_quantity: "报警数量",
    daily: "日",
    monthly: "月",
    yearly: "年",
    alarm_level: "报警等级",
    alarm_clearance: "告警消除",
    start_date: "开始日期",
    select_date: "选择日期",
    end_date: "结束日期",
    alarm_type: "报警等级",
    select_alarm_type: "请选择",
    alarm_status: "报警状态",
    select_alarm_status: "请选择",
    search: "搜索",
    reset: "重置",
    alarm_content: "报警内容",
    alarm_value: "报警值",
    confirmed: "已确认",
    not_confirmed: "未确认",
    operation: "操作",
    confirm: "确认",
    cancel: "取消"
  },
  energy: {
    energy_statistics: "节能量统计",
    today: "当日",
    this_month: "当月",
    this_year: "当年",
    energy_trends: "节能量趋势",
    co2_reduction: "减少CO2排放",
    total_co2_reduction: "累计减少CO2排放",
    energy_data: "节能量数据",
    start_date: "开始日期",
    end_date: "结束日期",
    select_month: "选择月份：",
    to: "至",
    search: "搜索",
    start_month: "开始月份",
    end_month: "结束月份",
    daily: "日",
    monthly: "月",
    yearly: "年"
  },
  operation: {
    sbgl: "设备管理",
    xjgd: "新建工单",
    gdgl: "工单管理"
  },
  sbgl: {
    device_name: "设备名称",
    device_desc: "设备描述",
    field_name: "关联点位",
    start_count: "启动次数",
    run_time: "运行时间(小时)",
    maintenance_time: "最近维保时间",
    maintenance_cycle: "维保周期(天)",
    maintenance_next: "距离下次维保(天)",
    operation: "操作",
    edit: "编辑",
    delete: "删除",
    search: "查询",
    reset: "重置",
    add_device: "录入设备",
    batch_import: "批量导入",
    download_template: "下载导入模板",
    batch_delete: "批量删除",
    select_date: "选择日期",
    today: "今天",
    confirm: "确认",
    cancel: "取消"
  },
  gdgl: (_gdgl = {
    entryName: "项目名称",
    workOrderType: "工单类型",
    workOrderStatus: "工单状态",
    filterTime: "提交时间",
    startDate: "开始日期",
    endDate: "结束日期",
    submit: "我提交的",
    review: "我处理的",
    send: "抄送我的",
    edit: "编辑",
    view: "查看",
    handler: "选择处理人",
    ccUser: "选择抄送人",
    detail: "处理内容",
    uploadImage: "上传图片(单张不得大于2M)",
    assign: "确认转让",
    close: "无需处理，直接关闭",
    complete: "处理完成",
    reassign: "处理不了，分配给别人",
    assignNext: "分配给下一个人",
    closeOrder: "处理完成,关闭工单"
  }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_gdgl, "entryName", "项目名称"), "workOrderTypeName", "工单类型"), "submitterName", "提交人"), "workOrderStatusName", "工单状态"), "handlerTypeName", "处理情况"), "createTime", "工单提交时间"), "workOrderDate", "最后更新时间"), "index", "序号"), "action", "操作"), "workOrderStatus_0", "未处理"), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_gdgl, "workOrderStatus_1", "处理中"), "workOrderStatus_2", "已关闭"), "handlerType_1", "待我处理"), "handlerType_2", "我处理中"), "handlerType_3", "处理完成"), "workOrderType", "工单类型"), "workOrderStatus", "工单状态"), "all", "全部"), "deviceFailure", "设备故障"), "other", "其他"), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_gdgl, "pending", "未处理"), "processing", "处理中"), "closed", "已关闭"), "reset", "重置")),
  xjgd: {
    title: "工单管理",
    selectProject: "选择项目",
    orderType: "工单类型",
    selectHandler: "选择处理人",
    selectCcUser: "选择抄送人",
    eventDescription: "事件描述",
    sitePhotos: "现场照片",
    submitOrder: "提交工单",
    projectPlaceholder: "请选择项目",
    orderTypePlaceholder: "请选择类型",
    handlerPlaceholder: "请选择处理人",
    ccUserPlaceholder: "请选择抄送人",
    descPlaceholder: "请输入描述",
    uploadImagePlaceholder: "上传图片",
    sbgz: "设备故障",
    qt: "其他"
  }
};